import { render, staticRenderFns } from "./DecksWidget.vue?vue&type=template&id=31c8e12c&"
import script from "./DecksWidget.vue?vue&type=script&lang=js&"
export * from "./DecksWidget.vue?vue&type=script&lang=js&"
import style0 from "./DecksWidget.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports